export const CAPTURE_WIDTH = 1280;
export const CAPTURE_HEIGHT = 720;
export const CAPTURE_INTERVAL = 200;
export const FACE_FOUND_STYLE = "face-found";
export const FACE_PASSED_STYLE = "face-passed";
export const IDFP_ERROR_MESSAGE = "Injection Attack Detection check failed";
